/**
 * Tour guide — Section Assistant Telegram
 */

const assistantTour = [
  {
    target: '[data-tour="assistant-stats"]',
    title: 'Vos indicateurs',
    content: 'Les 4 compteurs montrent vos prospects actifs, idees en brouillon, rendez-vous a venir et notes non traitees. Cliquez sur un compteur pour acceder directement a la liste.',
    position: 'bottom',
  },
  {
    target: '[data-tour="assistant-timeline"]',
    title: 'Chronologie recente',
    content: 'Les 20 derniers elements crees ou modifies, tous types confondus. Chaque entree est cliquable pour acceder au detail.',
    position: 'top',
  },
  {
    target: '[data-tour="assistant-upcoming"]',
    title: 'Prochains rendez-vous',
    content: 'Vos rendez-vous a venir sont affiches ici. Ils sont partages entre tous les utilisateurs pour la coordination d\'equipe.',
    position: 'top',
  },
  {
    target: null,
    title: 'Comment ca marche ?',
    content: 'Envoyez un message vocal ou texte au bot Telegram :\n\n• "Nouveau prospect chez Dupont, 50 postes" → Prospect\n• "RDV demain 14h avec Jean" → Rendez-vous\n• "Idee : ajouter un dashboard client" → Idee\n• Tout le reste → Note\n\nLe systeme classe automatiquement grace a des mots-cles. Vous pouvez aussi creer manuellement depuis chaque sous-section.',
    position: 'bottom',
  },
  {
    target: null,
    title: 'Donnees privees',
    content: 'Vos notes, prospects et idees sont prives — seul vous les voyez (et le superadmin). Les rendez-vous sont partages entre tous les utilisateurs.',
    position: 'bottom',
  },
];

export default assistantTour;
